import { render, staticRenderFns } from "./PersonalityDefault.vue?vue&type=template&id=3244c3a7&scoped=true&"
import script from "./PersonalityDefault.vue?vue&type=script&lang=js&"
export * from "./PersonalityDefault.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityDefault.vue?vue&type=style&index=0&id=3244c3a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244c3a7",
  null
  
)

export default component.exports